import { render, staticRenderFns } from "./EmailCardV2.vue?vue&type=template&id=3bf2478a&scoped=true&"
import script from "./EmailCardV2.vue?vue&type=script&lang=js&"
export * from "./EmailCardV2.vue?vue&type=script&lang=js&"
import style0 from "./EmailCardV2.vue?vue&type=style&index=0&id=3bf2478a&prod&lang=scss&"
import style1 from "./EmailCardV2.vue?vue&type=style&index=1&id=3bf2478a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf2478a",
  null
  
)

export default component.exports